var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require('@/assets/' + _vm.fileName),"alt":"Who We Serve logo"}}),_c('p',{staticClass:"is-size-4 has-text-weight-bold",style:({ color: 'rgb(51, 51, 51)' })},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }